/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import ContentLoader from "react-content-loader";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { confirmAlert } from "react-confirm-alert";
import SlidingPane from "react-sliding-pane";
import { ToastContainer, toast } from "react-toastify";
import CurrencyInput from "react-currency-input-field";
import CheckButton from "react-validation/build/button";
import MaterialTable, { MTableToolbar } from "material-table";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import EditContractService from "../../../../services/contract/editContractService";
import ACtivateContractService from "../../../../services/contract/activateContractService";
import { getTrans as t } from "../../../../Localization/translations";
import authHeader from "../../../../services/auth-header";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import Helper from "../../../../Helper";
import { API } from "../../../../backend";
import ContractShortview from "../contractshortview";
import PaymentScheduleList from "../../../../components/paymentScheduleList";
import AssetList from "../../../../components/assetList";
import AmortizationSchedule from "../AmortSchedulDetail/CalculateAmortSchedule";
import AmortizationScheduleArrears from "../AmortSchedulDetail/ArrearsAmortSchedule";
import AddPaymentScheduleService from "../../../../services/contract/paymentSchedule/addPaymentScheduleService";
import AssetView from "../Asset/AssetView";
import Doc from "../../../UploadDocument/doc";
import lineOfBusinessService from "../../../../services/company/lineofbusinessService";
import subcompanyService from "../../../../services/company/subcompanyService";
import PartyRoleList from "../../PartyRole/PartyRoleList";
import TermConditionContractView from "../../TermsCondition/TermConditionContractView";

function ContractEdit({ customerPermission, setCustomData }) {
  const { state } = useLocation();

  const userAgent = navigator.userAgent;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const assetId = searchParams.get("Asset");

  // Define a function to extract browser name and version
  const [items, setItems] = useState([]);
  const [paymentdetail, setPaymentDeatil] = useState([]);
  const [contract, setConract] = useState([]);
  const [paymentstartdate, setpaymentStartdate] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [status, setStatus] = useState("");
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState("");
  const [residual, setResidual] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [contract_iir, setContract_Iir] = useState("");
  const [address, setAddress] = useState([]);
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState("");
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [paymentrule, setPaymentRule] = useState("");
  const [paymentfrequency, setPaymentFrequency] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [financed_amount, setFianced_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [asset_count, setAsset_count] = useState(0);
  const [payment_count, setPayment_count] = useState(0);
  const [showActivate, setShowActivate] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeloading, setActiveLoading] = useState(false);
  const [no_of_payments, setNo_of_payments] = useState(null);
  const [Paymentend_date, setPaymentEnd_date] = useState(null);
  const [customer_id, setCustomer_id] = useState("");
  const [calu, SetCalu] = useState([]);
  const [amortcalculation, SetAmortCaluculation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState("");
  const [assetTabActivated, setAssetTabActivated] = useState(false);
  const [assetid, setassetID] = useState("");

  const [appOriginator, setAppOriginator] = useState("");
  const [source, setSource] = useState("");
  const [salesRep, setSalesRep] = useState("");
  const [subcompany, setSubcompany] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);
  const [isApprovalRequired, setIsApprovalRequired] = useState(false);
  //  amortization error state
  const [amortError, setAmortError] = useState("");

  const fetchSubcompanies = () => {
    try {
      subcompanyService.getSubcompany().then((response) => {
        setSubcompanyOptions(response.data || []);
        // if (response.data.length > 0) {
        //   setSubcompany(response.data[0].id); // Set default to first option
        //   reset({ subcompany: response.data[0].id });
        // }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch Lines of Business
  const fetchLinesOfBusiness = () => {
    try {
      lineOfBusinessService.getLineOfBusiness().then((response) => {
        setLineOfBusinessOptions(response.data || []);
        // if (response.data.length > 0) {
        //   setLineOfBusiness(response.data[0].id); // Set default to first option
        //   reset({ lineOfBusiness: response.data[0].id });
        // }
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSubcompanies();
    fetchLinesOfBusiness();
  }, []);

  useEffect(() => {
    setassetID(assetId);
  }, [assetId]);

  useEffect(() => {
    if (assetId && !assetTabActivated) {
      setTabContractIndex(2);
      setAssetTabActivated(true);
    }
  }, [assetId, assetTabActivated]);

  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [tabcontractIndex, setTabContractIndex] = useState(assetId ? 2 : 0);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [rentamount, setRentAmount] = useState([]);
  const [numberofpayment, setNumberofpayment] = useState(0);
  const [totalRent, setTotalRent] = useState(0);
  const [totalonetimefee, setTotalOneTimeFee] = useState(0);

  // payment
  const [payment_type, setPayment_type] = useState("Rent");
  const [amount, setAmount] = useState(null);
  const [frequency, setFrequency] = useState("Monthly");
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const form = useRef();
  const [disablecontract, setDisableContract] = useState(false);
  const [disableparty, setDisableParty] = useState(false);
  const [object_name, setObject_name] = useState("Contract");
  // add party customer
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();

  //party screen
  const [party_type, setParty_type] = useState("Customer");
  const [customer_type, setCustomer_type] = useState("");
  const [showhide, setShowHide] = useState("");
  const [customer_nameparty, setCustomer_nameParty] = useState("");
  const [establishment_date, setEstablishment] = useState(null);
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);

  // Address Screen
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("No");
  const [install_to, setInstall_to] = useState("Yes");

  const [pacakge, setPackage] = useState([]);
  const [companydata, setCompany] = useState([]);

  const [selectedBill, setSelectedBill] = useState(null);
  const [filterBill, setFilterBill] = useState([]);

  const [state1, setState1] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state5, setState5] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [rowsData, setRowsData] = useState([]);
  const [termError, setTermError] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [paymentType, setPaymentType] = useState([]);

  const form6 = useRef();
  const checkBtn6 = useRef();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    reset: reset6,
    // formState: { errors: errors5 },
  } = useForm();

  const [frequencyMapped, setFrequencyMapped] = useState({
    Monthly: 1,
    Quarterly: 3,
    SemiAnnual: 6,
    Annual: 12,
  });

  const [paymentFrequencystep, setPaymentFrequencystep] = useState([
    { value: 1, label: "Monthly" },
    { value: 3, label: "Quarterly" },
    { value: 6, label: "Semi-annual" },
    { value: 12, label: "Annual" },
  ]);

  const [achPayments, setAchPayments] = useState(false); // New state for ACH Payments checkbox
  const [achAccounts, setAchAccounts] = useState([]); // New state for ACH Accounts list
  const [achAccount, setAchAccount] = useState("");

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };
  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", {
      headers: authHeader(),
    });
    const getcon = await res.json();
    setPackage(getcon);
  };
  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setCompany(response.data);
    });
  };
  useEffect(() => {
    packagedata();
    company();
  }, []);
  const free = pacakge.filter((value) => value.name === companydata.plan);

  // const TotalIncome = calu.reduce((total, row) => {
  //   return total + row.income;
  // }, 0);
  const TotalIncome = (calu || []).reduce((total, row) => {
    return total + (row.income || 0);
  }, 0);

  const handleAddress = (id) => {
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddress_line_1("");
          setAddress_line_2("");
          setCity("");
          setStateAddress("");
          setZip_code("");
          setAdddressId(response.data.addressId);
        }
      });
    }
  };

  const handleparty = () => {
    setDisableParty(true);
    form2.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn2.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(
        customer_type,
        party_type,
        customer_nameparty
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setDisable(true);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleAddress(response.data.partyId);
          loadInitialOptions(customer_nameparty);
          reset({
            selectedValue: response.data.partyId,
          });
          setTimeout(() => {
            setDisableParty(false);
            setSelectedValue(response.data.partyId);
            setState1({ isPaneOpen: false });
          }, 1000);
          setCustomer_nameParty("");
          setCustomer_type("");
        } else {
          setLoading(false);
          setDisableParty(false);
          setSuccessful(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handlepartydefault = () => {
    AddPartyService.partyvalidate(customer_nameparty).then((response) => {
      if (response.data.success) {
        handleparty();
      } else {
        confirmAlert({
          title: "",
          message: `Party ${customer_nameparty} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    });
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    if (value === null) {
      setSelectedValue(value);
      reset({
        selectedValue: value,
      });
      setAddress([]);
      setAdddressId("");
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
    } else {
      setSelectedValue(value.id);
      reset({
        selectedValue: value.id,
        achPayments: false,
        achAccount: "",
      });
      const customerId = value.id;
      const customerName =
        value.name || value.label || value.customer_name || ""; // depends on your object shape

      fetchAchAccounts(customerId, "", false, false, customerName);
      // fetchAchAccounts(value.id); // Fetch ACH accounts for the new customer
    }
  };

  const fetchAchAccounts = async (
    customerId,
    contractAchId = "",
    useContractAchEnabled = false,
    contractAchEnabled = "N"
  ) => {
    if (!customerId) {
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      reset({ achPayments: false, achAccount: "" });
      return;
    }
    try {
      // Fetch ACH accounts for the customer
      const response = await axios.get(
        `${API}parties/api/ach-accounts/?party_id=${customerId}`,
        { headers: authHeader() }
      );
      const accounts = response.data.details || [];
      setAchAccounts(accounts);

      // Fetch customer data to get ACHPayments status
      let achEnabled = false;
      console.log("useContractAchEnabled:", useContractAchEnabled);

      if (useContractAchEnabled) {
        achEnabled = useContractAchEnabled;
      } else if (useContractAchEnabled === false) {
        achEnabled = useContractAchEnabled;
      } else {
        const customerResponse = await axios.get(
          `${API}parties/vendor/?party_type=Customer&customer_name=${customer_name}`,
          { headers: authHeader() }
        );
        const customer = customerResponse.data.data.find(
          (c) => c.id === customerId
        );
        achEnabled = customer?.ACHPayments || false;
      }
      // const customerResponse = await axios.get(
      //   `${API}parties/vendor/?party_type=Customer&customer_name=${customer_name}`,
      //   { headers: authHeader() }
      // );
      // const customer = customerResponse.data.data.find(
      //   (c) => c.id === customerId
      // );
      // // const achEnabled = customer?.ACHPayments || false;
      // const achEnabled = contract?.enable_ach || false;
      setAchPayments(achEnabled);

      // if (accounts.length === 0) {
      //   setAchAccount("");
      //   reset({ achPayments: achEnabled, achAccount: "" });
      // } else {
      //   // If contract has an ach_account_id, try to select it; otherwise, select none
      //   const contractAchAccount = accounts.find(
      //     (account) => account.id === contract.ach_account_id
      //   );
      //   const selectedAccountId = contractAchAccount ? contractAchAccount.id : "";
      //   setAchAccount(selectedAccountId);
      //   reset({ achPayments: achEnabled, achAccount: selectedAccountId });
      // }
      let selectedAccountId = "";

      if (accounts.length > 0) {
        const selectedAccount = accounts.find(
          (account) => account.id === contractAchId
        );
        selectedAccountId = selectedAccount ? selectedAccount.id : "";
      }

      setAchAccount(selectedAccountId);
      reset({ achPayments: achEnabled, achAccount: selectedAccountId });
    } catch (error) {
      console.error("Error fetching ACH accounts:", error);
      toast.error("Failed to load ACH accounts", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      reset({ achPayments: false, achAccount: "" });
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async (value) => {
    if (value !== undefined) {
      const responseJSON = await axios.get(
        API + `parties/vendor/?party_type=Customer&&customer_name=${value}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    } else {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    }
  };
  //
  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  useEffect(() => {
    getEndDate();
    loadInitialOptions();
  }, [start_date, contract_term]);

  const handelContract_term = (value) => {
    setContract_term(value);
    // setAmount(0)
    // reset({
    //    paymentamount:0
    // })
    setDataFetched(true);
  };

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    });
  };

  const getEndDate = () => {
    if (start_date === "") {
      return false;
    }
    var dt = new Date(start_date);
    var term = parseInt(contract_term);
    if (term !== "" && !isNaN(dt)) {
      dt.setMonth(dt.getMonth() + term);
      dt.setDate(dt.getDate() - 1);
      setEnd_date(dt);
    }
  };

  const getaddress = async () => {
    if (selectedValue !== null) {
      const resst = await fetch(
        API +
        "parties/manage-address/" +
        selectedValue +
        "/?address_type=bill_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setAddress(await getst.data);
      if (address_id !== "") {
        setAdddressId(address_id);
      } else {
        setAdddressId(await getst.data[0].id);
        reset({
          address: await getst.data[0].id,
        });
      }
    }
  };

  const loadOptionBillAdd = async (inputValue, callback) => {
    const filteredOptions = address
      .filter((address) =>
        `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      )
      .map((address) => ({
        value: address.id,
        label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
      }));

    setFilterBill(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
    }));
    setFilterBill(options);
  }, [address]);

  const handleBillAddressChange = (selectedOption) => {
    if (selectedOption) {
      setAdddressId(selectedOption.value);
      reset({ address: selectedOption.value });
    } else {
      setAdddressId(null);
      setSelectedBill(null);
      reset({ address: null });
    }
  };

  const data_count = (items) => {
    if (items === "") setShowActivate(0);
    else setShowActivate(1);
  };

  const handleTabClick = (index) => {
    setTabContractIndex(index);
  };

  useEffect(() => {
    setIsLoading(true);
    EditContractService.getContract(state).then((response) => {
      setContract_number(response.data.contract_number);
      setStart_date(response.data.start_date);
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setEnd_date(response.data.end_date);
      setContract_Iir(response.data.iir);
      setConract(response.data);
      setCustomer_name(response.data.customer_name);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setDeposit_amount(response.data.deposit_amount);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setAsset_count(response.data.asset_count);
      setPayment_count(response.data.payment_count);
      setStatus(response.data.status);
      setLoanAmount(response.data.loanamount);
      setFianced_amount(response.data.financed_amount);
      setPaymentRule(response.data.paymentrule);
      setResidual(response.data.asset_residual);
      setpaymentStartdate(response.data.paymentstartdate);
      setPaymentFrequency(response.data.paymentfrequency);
      setAmount(response.data.periodicpayment_amount);
      setTotalRent(response.data.payment_rent_sum);
      setTotalOneTimeFee(response.data.one_time_fee_sum);
      setAchPayments(response.data.enable_ach || false);
      setAchAccount(response.data.ach_account_id || "");
      setAppOriginator(response.data.appOriginator || "");
      setSource(response.data.source || "");
      setSalesRep(response.data.salesRep || "");
      setSubcompany(
        response.data.subcompany ? parseInt(response.data.subcompany) : ""
      );
      setLineOfBusiness(
        response.data.line_of_business
          ? parseInt(response.data.line_of_business)
          : ""
      );
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);
      setIsLoading(false);
      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
        paymentamount: response.data.periodicpayment_amount,
        achPayments: response.data.enable_ach || false,
        achAccount: response.data.ach_account_id || "",
        subcompany: response.data.subcompany
          ? String(response.data.subcompany)
          : "",
        lineOfBusiness: response.data.line_of_business
          ? String(response.data.line_of_business)
          : "",
      });
      if (response.data.party) {
        fetchAchAccounts(
          response.data.party,
          response.data.ach_account_id,
          (response.data.enable_ach =
            response.data.enable_ach === "Y" ? true : false), // use contract flag
          response.data.enable_ach
        ); // Fetch ACH accounts for the initial customer
      }
      fetchSubcompanies();
      fetchLinesOfBusiness();
      handlepaymentdetailview();
    });
  }, []);


  useEffect(() => {
    axios.get(API + "accounting/transactiontypesview/?", {
      headers: authHeader()
    })
      .then(res => {
        console.log("API DATA:", res.data);

        // ✅ FIX 1: correct data path
        const transactionList = res.data.data || [];

        console.log("Transaction List:", transactionList);

        // ✅ FIX 2: correct find condition
        const activation = transactionList.find(
          (item) =>
            item.transaction_type === "Activation" ||
            item.description === "Activation"
        );

        console.log("FINAL Activation:", activation);

        if (activation) {
          const approvalFlag = (activation.approval || "")
            .trim()
            .toUpperCase();

          setIsApprovalRequired(approvalFlag === "Y");
        } else {
          console.warn("Activation NOT FOUND");
        }
      })
      .catch(err => {
        console.error("API ERROR:", err);
      });
  }, []);

  const handelStart_Date = (value) => {
    setStart_date(value);
    // setAmount(0)
    // reset({
    //   paymentamount:0
    // })
    setDataFetched(true);
    reset({
      startdate: value,
    });
  };

  useEffect(() => {
    data_count();
    setTimeout(() => {
      getaddress();
    }, 2000);
  }, [selectedValue]);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} 00:00:00`;
  };

  const handleactivation = () => {
    if (contract_iir < 0) {
      confirmAlert({
        title: "",
        message:
          "Rent is less than Asset value - Residual. Please update Asset Values or Rent.",
        buttons: [
          {
            label: "OK",
          },
        ],
      });
      return;
      // } else if (Helper.Dateview(start_date) <= Helper.Dateview(formatDate(new Date()))) {
    } else if (new Date(start_date) <= new Date()) {
      handleActivate();
    } else {
      confirmAlert({
        title: "",
        message: "Contract starts on a future date. Confirm activation",
        buttons: [
          {
            label: "Continue and Activate",
            onClick: () => handleActivate(),
          },
          {
            label: "Cancel",
          },
        ],
      });
    }
  };

  const handleActivate = () => {
    setActiveLoading(true);
    ACtivateContractService.activateContract(state, paymentdetail, calu).then(
      (response) => {
        if (response.data.success) {
          setSuccessful(true);
          setActiveLoading(false);
          setTimeout(() => {
            navigate("/contract");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setSuccessful(false);
          setLoading(false);
          setActiveLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }
    );
  };

  const isFirstDayOfMonth = (date) => {
    return date.getDate() === 1;
  };

  let navigate = useNavigate();

  const isLastDayOfMonth = (date) => {
    const tempDate = new Date(date);
    tempDate.setDate(tempDate.getDate() + 1);
    return tempDate.getDate() === 1;
  };

  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  // Check if a month is February (0-based index, so February is 1)
  function isFebruary(date) {
    return date.getMonth() === 1;
  }

  const getLastDayOfMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();

  const setenddate = (no_of_payments) => {
    if (start_date === "") {
      return false;
    }

    var contractDateObj = new Date(start_date);
    // Define a mapping for payment frequencies
    const frequencyMapping = {
      Monthly: { months: 1 },
      Quarterly: { months: 3 },
      "Semi-annual": { months: 6 },
      Annual: { months: 12 },
    };
    // Calculate the payment start date based on the payment rule
    let paymentStartDate, paymentEndDate;
    if (paymentrule === "Advance") {
      paymentStartDate = contractDateObj;
    } else if (paymentrule === "Arrears") {
      const cycleDelta = frequencyMapping[paymentfrequency];
      const originalDay = contractDateObj.getDate();

      let targetYear = contractDateObj.getFullYear();
      let targetMonth = contractDateObj.getMonth() + cycleDelta.months;

      // Get last valid day of target month
      const lastDay = getLastDayOfMonth(targetYear, targetMonth);

      // If original day > last day, clamp to last day
      const targetDay = Math.min(originalDay, lastDay);

      paymentStartDate = new Date(targetYear, targetMonth, targetDay);
      // if (isFirstDayOfMonth(contractDateObj)) {
      //   paymentStartDate = new Date(contractDateObj);
      //   paymentStartDate = new Date(
      //     paymentStartDate.getFullYear(),
      //     paymentStartDate.getMonth() + cycleDelta.months,
      //     1
      //   );
      //   // paymentStartDate.setDate(paymentStartDate.getDate() - 1)
      //   paymentStartDate.setDate(paymentStartDate.getDate());
      // } else if (isLastDayOfMonth(contractDateObj)) {
      //   // For non-February months, set to last day of target month if original is last day
      //   // paymentStartDate.setDate(1); // Move to 1st of next month
      //   paymentStartDate = new Date(contractDateObj);
      //   paymentStartDate = new Date(
      //     paymentStartDate.getFullYear(),
      //     paymentStartDate.getMonth() + cycleDelta.months
      //   );
      //   // console.log("set new month date", paymentd);
      //   // paymentStartDate.setMonth(paymentStartDate.getMonth() + cycleDelta.months);
      //   if (isFebruary(paymentStartDate)) {
      //     // If target month is February, set to 29 (leap year) or 28 (non-leap year)
      //     paymentStartDate.setDate(
      //       isLeapYear(paymentStartDate.getFullYear()) ? 29 : 28
      //     );
      //   } // No setDate(0) here; keep the adjusted date (e.g., Jan 31 for Dec 31)
      //   else {
      //     console.log("set date", paymentStartDate.getDate());
      //     paymentStartDate.setMonth(
      //       paymentStartDate.getMonth() + cycleDelta.months
      //     );
      //     paymentStartDate.setDate(0);
      //   }
      // } else {
      //   paymentStartDate = new Date(contractDateObj);
      //   paymentStartDate.setMonth(
      //     paymentStartDate.getMonth() + cycleDelta.months
      //   );
      //   if (isFebruary(paymentStartDate) && originalDay >= 30) {
      //     // For dates >= 30 in January, set to 29 (leap year) or 28 (non-leap year)
      //     paymentStartDate.setDate(
      //       isLeapYear(paymentStartDate.getFullYear()) ? 30 : 29
      //     );
      //   } else {
      //     // Otherwise, keep the original day
      //     paymentStartDate.setDate(originalDay);
      //   }
      // }
      // if (isFirstDayOfMonth(contractDateObj)) {
      //     paymentStartDate = new Date(contractDateObj);
      //     paymentStartDate = new Date(
      //       paymentStartDate.getFullYear(),
      //       paymentStartDate.getMonth() + cycleDelta.months,
      //       1
      //     );
      //     paymentStartDate.setDate(paymentStartDate.getDate() - 1);
      //   } else {
      //     // paymentStartDate = new Date(contractDateObj);
      //     paymentStartDate = new Date(
      //       contractDateObj.getFullYear(),
      //       contractDateObj.getMonth() + cycleDelta.months
      //     );
      //     // paymentStartDate.setMonth(
      //     //   paymentStartDate.getMonth() + cycleDelta.months
      //     // );
      //     if (
      //       paymentStartDate.getMonth() === 1 &&
      //       contractDateObj.getDate() > 28
      //     ) {
      //       // If the month is February
      //       const year = paymentStartDate.getFullYear();

      //       const lastDayOfFeb = isLeapYear(year) ? 30 : 29;
      //       paymentStartDate.setDate(lastDayOfFeb - 1);
      //     } else {
      //       paymentStartDate.setDate(contractDateObj.getDate() - 1);
      //     }
      //     // paymentStartDate.setDate(paymentStartDate.getDate() - 1)
      //   }

    }
    const noofpayment = frequencyMapping[paymentfrequency];
    setNo_of_payments(contract_term / noofpayment.months);
    paymentEndDate = new Date(contractDateObj);
    paymentEndDate.setMonth(
      paymentEndDate.getMonth() + parseInt(contract_term)
    );
    paymentEndDate.setDate(paymentEndDate.getDate() - 1);
    setpaymentStartdate(Helper.DatePicker(paymentStartDate));
    setPaymentEnd_date(Helper.DatePicker(paymentEndDate));
  };

  useEffect(() => {
    if (paymentfrequency === "Monthly") {
      setenddate(contract_term / 1);
    }
    if (paymentfrequency === "Quarterly") {
      setenddate(contract_term / 3);
    }
    if (paymentfrequency === "Semi-annual") {
      setenddate(contract_term / 6);
    }
    if (paymentfrequency === "Annual") {
      setenddate(contract_term / 12);
    }
  }, [
    no_of_payments,
    start_date,
    contract_term,
    paymentrule,
    paymentfrequency,
  ]);

  const handleiir = () => {
    let url = API + "contracts/contractiir/?";
    url += "id=" + state;
    axios.get(url, { headers: authHeader() });
  };

  const handlepaymentscreen = (id) => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    let startdate = "";

    if (checkBtn.current.context._errors.length === 0) {
      AddPaymentScheduleService.UpdatePaymentSchedule(
        id,
        no_of_payments,
        payment_type,
        amount,
        frequency,
        Helper.DatePicker(start_date),
        Helper.DatePicker(Paymentend_date),
        rowsData
      ).then((response) => {
        if (response.data.success) {
          setDataFetched(false);
          setSuccessful(true);
          setLoading(false);
          setState5({ isPaneOpen: false });
        }
      });
    }
  };

  const handleRegister = (id) => {
    setSuccessful(false);
    setLoading(true);
    setDisableContract(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      try {
        let totalPayments = 0;
        rowsData.forEach((row) => {
          if (row.payment_type === "Rent") {
            totalPayments += parseInt(row.no_of_payments);
            setLoading(false);
            setDisableContract(false);
            return totalPayments;
          }
        });
        let contractTerm;

        if (paymentfrequency === "Monthly") {
          contractTerm = contract_term / frequencyMapped.Monthly;
        } else if (paymentfrequency === "Quarterly") {
          contractTerm = contract_term / frequencyMapped.Quarterly;
        } else if (paymentfrequency === "Semi-annual") {
          contractTerm = contract_term / frequencyMapped.SemiAnnual;
        } else if (paymentfrequency === "Annual") {
          contractTerm = contract_term / frequencyMapped.Annual;
        }
        if (totalPayments !== contractTerm) {
          toast.error(
            `Total Rent payments (${totalPayments}) do not match the contract term (${contractTerm}) months.`,
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
          setLoading(false);
          setDisableContract(false);
          return;
        } else {
          EditContractService.editContract(
            state,
            contract_number,
            contract_term,
            Helper.DatePicker(start_date),
            Helper.DatePicker(end_date),
            address_id,
            contract_type,
            deposit_amount,
            feesontime,
            tax_rate_rent,
            tax_rate_fee,
            selectedValue,
            paymentrule,
            attribute,
            paymentfrequency,
            Helper.DatePicker(paymentstartdate),
            no_of_payments,
            Paymentend_date,
            amount,
            achPayments,
            achAccount,
            appOriginator,
            source,
            salesRep,
            subcompany,
            lineOfBusiness
          )
            .then((response) => {
              if (response.data.success) {
                setSuccessful(true);
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setTimeout(() => {
                  setDisableContract(false);
                  handleiir(state);
                }, 2000);
                setTimeout(() => {
                  handlecl();
                }, 3000);
                setTimeout(() => {
                  handlepaymentscreen(state);
                }, 1000);
              } else {
                setSuccessful(false);
                setDataFetched(false);
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
              setLoading(false);
              setDisableContract(false);
              setDataFetched(false);
            })
            .catch((error) => {
              setLoading(false);
              setDisableContract(false);
              setSuccessful(false);
              setDataFetched(false);
            });
        }
      } catch (e) {
        setLoading(false);
        setSuccessful(false);
        setDisableContract(false);
        setDataFetched(false);
      }
    } else {
      setLoading(false);
      setDisableContract(false);
    }
  };

  useEffect(() => {
    getExtrafiled();
  }, []);
  const [feedefination, setFeeDefination] = useState([]);

  // const FeeDefination = () => {
  //   let url =
  //     API +
  //     "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes";
  //   axios.get(url, { headers: authHeader() }).then((response) => {
  //     setFeeDefination(response.data);
  //     setPaymentType(response.data);
  //   });
  // };

  const FeeDefination = () => {
    let url = API + "expenses/fee-types/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setPaymentType(response.data);
    });
  };

  useEffect(() => {
    FeeDefination();
  }, []);

  const [refreshdetail, setRefreshPaymentDetails] = useState(false);

  useEffect(() => {
    if (paymentdetail.length === 0) {
      if (contract.length !== 0) {
        handlepaymentdetailview();
      }
    }
    if (refreshdetail === true) {
      handlepaymentdetailview();
    }
  }, [contract, refreshdetail]);

  const handlepaymentdetailview = () => {
    let url = API + "contracts/payment-view/" + state + "/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      if (contract_type === "Lease") {
        try {
          const responsepay = axios.get(
            `${API}contracts/paymentScheduleCalculation/?id=${state}`,
            {
              headers: authHeader(),
            }
          );
          responsepay.then((response) => {
            {
              setPaymentDeatil(response.data.response);
            }
          });
          // setPaymentDeatil(responsepay.data.response)
        } catch (error) {
          console.error("Error fetching payment data:", error);
        }
      } else {
        setPaymentDeatil(
          Helper.calculatePaymentDates(
            start_date,
            paymentrule,
            payment_count,
            paymentfrequency,
            contract_term,
            response.data,
            feedefination
          )
        );
      }

      // setPaymentDeatil(
      // Helper.calculatePaymentDates(
      //   start_date,
      //   paymentrule,
      //   payment_count,
      //   paymentfrequency,
      //   contract_term,
      //   response.data,
      //   feedefination
      // )
      // );
      var sumOfRentAmount = 0;
      var sumofNoofpayment = 0;
      let rentAmounts = [];
      // for (let rent in response.data.data) {
      //   console.log("rentamounttt",rent)
      //   if (response.data.data[rent].payment_type === "Rent") {
      //     // sumOfRentAmount += response.data.data[rent].amount;
      //     sumOfRentAmount = response.data.data[rent].amount;  // For Payment Rent amount is calculate based on payment amount
      //     sumofNoofpayment += response.data.data[rent].no_of_payments;
      //     console.log("sum--",sumofNoofpayment)
      //     // rentAmounts.push({
      //     //   amount:  response.data.data[rent].amount,
      //     //   no_of_payments: response.data.data[rent].no_of_payments
      //     // });
      //     const no_of_paymentss = response.data.data[rent].no_of_payments;
      //     //         if (paymentfrequency =="Quarterly"){

      //     //           for (let j = 0; j < sumofNoofpayment * 3; j++) {

      //     //             rentAmounts.push(
      //     //               response.data.data[rent].amount
      //     //               // amount:  response.data.data[rent].amount,
      //     //               // no_of_payments: j+1 // Assuming each payment has a single payment
      //     //             );
      //     //         }
      //     //       }
      //     //       else if(paymentfrequency =="Semi-annual"){

      //     //       for (let j = 0; j < sumofNoofpayment * 6; j++) {

      //     //         rentAmounts.push(
      //     //           response.data.data[rent].amount
      //     //         );
      //     //     }

      //     //   }
      //     //   else if(paymentfrequency =="Annual"){

      //     //   for (let j = 0; j < sumofNoofpayment * 12; j++) {

      //     //     rentAmounts.push(
      //     //       response.data.data[rent].amount
      //     //     );
      //     // }
      //     //       }
      //     //       else{
      //     //           for (let j = 0; j < no_of_paymentss; j++) {

      //     //             rentAmounts.push(
      //     //               response.data.data[rent].amount
      //     //               // amount:  response.data.data[rent].amount,
      //     //               // no_of_payments: j+1 // Assuming each payment has a single payment
      //     //             );
      //     //         }

      //     //         }
      //     let interval;
      //     switch (paymentfrequency) {
      //       case "Quarterly":
      //         interval = 3;
      //         break;
      //       case "Semi-annual":
      //         interval = 6;
      //         break;
      //       case "Annual":
      //         interval = 12;
      //         break;
      //       default:
      //         interval = 1;
      //     }
      //     if (paymentrule == "Advance") {
      //       console.log("intervel---",interval)

      //       for (let i = 0; i < parseInt(sumofNoofpayment) * parseInt(interval); i++) {
      //         console.log("inter print 000iiiiiii",i)
      //         if (i % interval === 0) {
      //           rentAmounts.push(response.data.data[rent].amount);
      //         } else {
      //           rentAmounts.push(0);
      //         }
      //       }
      //     }
      //     else {
      //       for (let i = 0; i < sumofNoofpayment * interval; i++) {
      //         console.log("inter print 000iiiiiii----------",i)
      //         if ((i + 1) % interval === 0) {
      //           rentAmounts.push(response.data.data[rent].amount);
      //         } else {
      //           rentAmounts.push(0);
      //         }
      //       }

      //     }

      //   }
      // }
      response.data.forEach((rentItem) => {
        if (rentItem.payment_type === "Rent") {
          sumOfRentAmount = rentItem.amount;
          sumofNoofpayment += rentItem.no_of_payments;

          let interval;
          switch (paymentfrequency) {
            case "Quarterly":
              interval = 3;
              break;
            case "Semi-annual":
              interval = 6;
              break;
            case "Annual":
              interval = 12;
              break;
            default:
              interval = 1;
          }

          if (paymentrule == "Advance") {
            for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
              if (i % interval === 0) {
                rentAmounts.push(rentItem.amount);
              } else {
                rentAmounts.push(0);
              }
            }
          } else {
            for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
              if ((i + 1) % interval === 0) {
                rentAmounts.push(rentItem.amount);
              } else {
                rentAmounts.push(0);
              }
            }
          }
        }
      });

      setRentAmount(rentAmounts);
      switch (paymentfrequency) {
        case "Monthly":
          setNumberofpayment(sumofNoofpayment);
          break;
        case "Quarterly":
          setNumberofpayment(sumofNoofpayment * 3);
          break;
        case "Annual":
          setNumberofpayment(sumofNoofpayment * 12);
          break;
        case "Semi-annual":
          setNumberofpayment(sumofNoofpayment * 6);
          break;
        default:
          setNumberofpayment(sumofNoofpayment);
      }
      setRefreshPaymentDetails(false);
    });
  };
  const clickontab = () => {
    handlecl();
    handlepaymentdetailview();
  };
  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...attribute];
    rowsInput[index][name] = value;
    setAttribute(rowsInput);
  };

  const handlecl = () => {
    setLoading(true);
    setIsLoading(true);
    EditContractService.getContract(state).then((response) => {
      setKey(response.data);
      setContract_number(response.data.contract_number);
      setStart_date(response.data.start_date);
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setEnd_date(response.data.end_date);
      setContract_Iir(response.data.iir);
      setConract(response.data);
      setCustomer_name(response.data.customer_name);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setDeposit_amount(response.data.deposit_amount);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setAsset_count(response.data.asset_count);
      setPayment_count(response.data.payment_count);
      setStatus(response.data.status);
      setLoanAmount(response.data.loanamount);
      setFianced_amount(response.data.financed_amount);
      setPaymentRule(response.data.paymentrule);
      setResidual(response.data.asset_residual);
      setpaymentStartdate(response.data.paymentstartdate);
      setPaymentFrequency(response.data.paymentfrequency);
      setAmount(response.data.periodicpayment_amount);
      setTotalRent(response.data.payment_rent_sum);
      setTotalOneTimeFee(response.data.one_time_fee_sum);
      setAchPayments(response.data.enable_ach || false);
      setAchAccount(response.data.ach_account_id || "");
      setAppOriginator(response.data.appOriginator || "");
      setSource(response.data.source || "");
      setSalesRep(response.data.salesRep || "");
      setSubcompany(
        response.data.subcompany ? String(response.data.subcompany) : ""
      );
      setLineOfBusiness(
        response.data.line_of_business
          ? String(response.data.line_of_business)
          : ""
      );
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);

      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
        paymentamount: response.data.periodicpayment_amount,
        achPayments: response.data.enable_ach || false,
        achAccount: response.data.ach_account_id || "",
        subcompany: response.data.subcompany
          ? parseInt(response.data.subcompany)
          : "",
        lineOfBusiness: response.data.line_of_business
          ? parseInt(response.data.line_of_business)
          : "",
      });
      handlepaymentdetailview();
      setLoading(false);
      if (response.data.party) {
        fetchAchAccounts(
          response.data.party,
          response.data.ach_account_id,
          (response.data.enable_ach =
            response.data.enable_ach === "Y" ? true : false), // use contract flag
          response.data.enable_ach
        ); // Fetch ACH accounts for the initial customer
      }
      fetchSubcompanies();
      fetchLinesOfBusiness();
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (paymentdetail.length === 0) {
      SetCalu([]);
      SetAmortCaluculation([]);
    } else {
      if (no_of_payments && rentamount.length > 0) {
        // let totalRentAmount = 0;
        // let remainingPayments = no_of_payments;

        // console.log("reaming payment--",no_of_payments)
        // for (let rentDetail of rentamount) {
        //   if (rentDetail.no_of_payments > 0) {
        //     let applicablePayments = Math.min(remainingPayments, rentDetail.no_of_payments);
        //     console.log("applicable--",applicablePayments)
        //     totalRentAmount = rentDetail.amount;
        //     console.log("applicable-- amount",totalRentAmount)
        //     remainingPayments -= applicablePayments;
        //   } else {
        //     break;
        //   }
        // }

        if (paymentrule === "Advance") {
          try {
            const response = axios.get(
              `${API}contracts/amortCalculation/?id=${state}`,
              {
                headers: authHeader(),
              }
            );
            // response.then((response )=>{{SetAmortCaluculation(response.data.response)}console.log("data---",response.data.response)})
            response.then((response) => {
              {
                SetCalu(response.data.response);
                setAmortError(response.data.errors || "");
              }
            });
          } catch (error) {
            console.error("Error fetching payment data:", error);
          }

          // try {
          //   const responsepay = axios.get(`${API}contracts/paymentScheduleCalculation/?id=${state}`, {
          //     headers: authHeader(),
          //   });
          //   responsepay.then((response) => { console.log("data-- of payment-", response.data.response) })
          // } catch (error) {
          //   console.error('Error fetching payment data:', error);
          // }

          // SetCalu(
          //   Helper.generateLeaseSchedule(
          //     start_date,
          //     numberofpayment,
          //     financed_amount,
          //     rentamount,
          //     paymentfrequency,
          //     contract_iir,
          //     residual
          //   )
          // );
        } else {
          try {
            const response = axios.get(
              `${API}contracts/amortCalculation/?id=${state}`,
              {
                headers: authHeader(),
              }
            );
            // response.then((response )=>{{SetAmortCaluculation(response.data.response)}console.log("data---",response.data.response)})
            response.then((response) => {
              SetCalu(response.data.response);
              setAmortError(response.data.errors || "");
            });
          } catch (error) {
            console.error("Error fetching payment data:", error);
          }
          // try {
          //   const responsepay = axios.get(`${API}contracts/paymentScheduleCalculation/?id=${state}`, {
          //     headers: authHeader(),
          //   });
          //   responsepay.then((response) => { console.log("data-- of payment-", response.data.response) })
          // } catch (error) {
          //   console.error('Error fetching payment data:', error);
          // }

          // SetCalu(
          //   Helper.generateLeaseArrearsSchedule(
          //     start_date,
          //     numberofpayment,
          //     financed_amount,
          //     rentamount,
          //     paymentfrequency,
          //     contract_iir,
          //     residual
          //   )
          // );
        }
      }
    }
  }, [
    no_of_payments,
    numberofpayment,
    start_date,
    contract_iir,
    rentamount,
    paymentrule,
    financed_amount,
    residual,
    paymentdetail,
  ]);

  // const totalIncome = calu.reduce((sum, val) => sum + (val.income || 0), 0);
  // const totalIncome = calu.reduce((sum, val) => sum + val.income, 0);
  const totalIncome = (calu || []).reduce(
    (sum, val) => sum + (val.income || 0),
    0
  );

  // const totalRent = numberofpayment * key.periodicpayment_amount

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name,
    });
  }, [object_name, setCustomData, state]);

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    setTermError("");
  };

  const handelChangeAmount = (index, event) => {
    setTermError("");
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].amount = event;

    setRowsData(updatedRowsData);
  };

  const handleTermChange = (index, value) => {
    const termMonths = parseInt(value);
    const updatedRowsData = [...rowsData];
    const currentType = updatedRowsData[index].payment_type;
    let startDate = new Date(start_date);
    let paymentstartDate = new Date(start_date);

    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstartdate);
    }
    setTermError("");
    if (currentType === "Rent") {
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      if (paymentfrequency === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Rent"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
              // if(paymentrule === 'Advance'){
              //    startDate = new Date(start_date)
              //   }else{
              //     startDate = new Date(paymentstartdate)
              // }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Rent") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
                paymentstartDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule ==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + termMonths);
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);

            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (paymentfrequency === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
              paymentstartDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            let paymentstartDate;

            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    } else if (currentType === "Maintenance Fee") {
      let frequencyData;
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      frequencyData = updatedRowsData[index].payment_frequency;

      if (frequencyData === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Maintenance Fee"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
              if (paymentrule === "Advance") {
                paymentstartDate = new Date(start_date);
              } else {
                paymentstartDate = new Date(paymentstartdate);
              }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);
            updatedRowsData[index].payment_frequency = "Monthly";
            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (frequencyData === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(start_date);
            } else {
              paymentstartDate = new Date(paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
              //   if(paymentrule === 'Advance'){
              //     startDate = new Date(start_date)

              //    }else{

              //      startDate = new Date(paymentstartdate)
              //  }
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    } else {
      // All other fee types (Security Deposit, Late Fee, Origination Fee, etc.)
      const frequencyData = updatedRowsData[index].payment_frequency || frequency;
      updatedRowsData[index].no_of_payments = value;

      if (value === "") {
        updatedRowsData[index].start_date = "";
        updatedRowsData[index].end_date = "";
        updatedRowsData[index].paymentstart_date = "";
      } else if (!isNaN(termMonths) && termMonths > 0) {
        const frequencyMonths = { Monthly: 1, Quarterly: 3, "Semi-annual": 6, Annual: 12 };
        const months = (frequencyMonths[frequencyData] || 1) * termMonths;
        const rowStartDate = new Date(start_date);
        const rowEndDate = new Date(rowStartDate);
        rowEndDate.setMonth(rowEndDate.getMonth() + months);
        rowEndDate.setDate(rowEndDate.getDate() - 1);
        updatedRowsData[index].start_date = Helper.DatePicker(rowStartDate);
        updatedRowsData[index].end_date = Helper.DatePicker(rowEndDate);
        updatedRowsData[index].paymentstart_date = Helper.DatePicker(rowStartDate);
      }

      setRowsData(updatedRowsData);
    }
  };

  const addTableRows = () => {
    const rowsInput = {
      no_of_payments: "",
      payment_type: "Rent",
      payment_frequency: paymentfrequency,
      start_date: "",
      end_date: "",
      amount: null,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const handlePayment = () => {
    const term = rowsData.map((val) => val.no_of_payments);
    const amount = rowsData.map((val) => val.amount);
    setTermError("");

    let contractTerm = null;
    if (paymentfrequency === "Monthly") {
      contractTerm = contract_term / frequencyMapped.Monthly;
    } else if (paymentfrequency === "Quarterly") {
      contractTerm = contract_term / frequencyMapped.Quarterly;
    } else if (paymentfrequency === "Semi-annual") {
      contractTerm = contract_term / frequencyMapped.SemiAnnual;
    } else if (paymentfrequency === "Annual") {
      contractTerm = contract_term / frequencyMapped.Annual;
    }
    const totalPayments = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);
      return row.payment_type === "Rent"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);
    // const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
    //   const payments = parseInt(row.no_of_payments, 10);
    //   return row.payment_type === 'Maintenance Fee' ? sum + (isNaN(payments) ? 0 : payments) : sum;
    // }, 0);
    let rowContractTerm = null;
    const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);

      if (row.payment_type === "Maintenance Fee") {
        if (row.payment_frequency === "Monthly") {
          rowContractTerm = contract_term / frequencyMapped.Monthly;
        } else if (row.payment_frequency === "Quarterly") {
          rowContractTerm = contract_term / frequencyMapped.Quarterly;
        } else if (row.payment_frequency === "Semi-annual") {
          rowContractTerm = contract_term / frequencyMapped.SemiAnnual;
        } else if (row.payment_frequency === "Annual") {
          rowContractTerm = contract_term / frequencyMapped.Annual;
        }
      }

      return row.payment_type === "Maintenance Fee"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);

    if (term.includes("") || term.includes(0)) {
      setTermError("No of payment is required");
      return;
    }
    if (amount.includes("") || amount.includes(null)) {
      setTermError("Amount is required");
      return;
    }

    const negativeAmount = amount.some((a) => parseFloat(a) < 0);
    if (negativeAmount) {
      setTermError("Only positive numbers are allowed");
      return;
    }

    if (totalPayments !== contractTerm) {
      setTermError(`Total number of Rent term ${contractTerm} is required`);
      return;
    }

    if (totalPaymentsMaintentence > rowContractTerm) {
      setTermError(
        `Total number of Maintenance term ${rowContractTerm} is required`
      );
      return;
    }

    if (!termError) {
      setTimeout(() => {
        handleRegister();
      }, 1000);
    } else {
      setRowsData([...rowsData]);
    }
  };

  const fetchPaymentData = async () => {
    try {
      const response = await axios.get(
        `${API}contracts/payment-view/${state}/`,
        {
          headers: authHeader(),
        }
      );
      const rowValue = response.data;
      const rowsInput = rowValue.map((val) => ({
        no_of_payments: val.no_of_payments,
        payment_frequency: val.frequency,
        start_date: Helper.DatePicker(val.start_date),
        end_date: Helper.DatePicker(val.end_date),
        payment_type: val.payment_type,
        amount: val.amount,
      }));
      setRowsData(rowsInput);
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  };
  useEffect(() => {
    fetchPaymentData();
  }, []);

  useEffect(() => {
    if (dataFetched && contract_term !== "") {
      let contractTerm = null;
      let startDate;
      let endDate;
      let paymentstartDate;

      if (paymentfrequency === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + contractTerm);
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.Quarterly * contractTerm;
        endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.SemiAnnual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month);
        endDate.setDate(endDate.getDate() - 1);
      } else if (paymentfrequency === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
        startDate = new Date(start_date);
        if (paymentrule === "Advance") {
          paymentstartDate = new Date(start_date);
        } else {
          paymentstartDate = new Date(paymentstartdate);
        }
        endDate = new Date(startDate);
        const month = frequencyMapped.Annual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month);
        endDate.setDate(endDate.getDate() - 1);
      }

      const rentRow = {
        no_of_payments: contractTerm,
        payment_type: "Rent",
        payment_frequency: paymentfrequency,
        start_date: Helper.DatePicker(startDate),
        end_date: Helper.DatePicker(endDate),
        amount: amount,
        paymentstart_date: Helper.DatePicker(paymentstartDate),
      };
      setRowsData((prevRowsData) => {
        const updatedRows = prevRowsData
          .filter((row) => row.payment_type !== "Rent")
          .map((row) => {
            const oneTimeFeeValues = paymentType
              .filter((pt) => pt.fee_nature === "One Time")
              .map((pt) => pt.value);
            if (oneTimeFeeValues.includes(row.payment_type)) {
              const feeStartDate = new Date(start_date);
              const feeEndDate = new Date(feeStartDate);
              const feeTerm = row.no_of_payments;
              let monthsToAdd = feeTerm;
              if (paymentfrequency === "Quarterly") {
                monthsToAdd = frequencyMapped.Quarterly * feeTerm;
              } else if (paymentfrequency === "Semi-annual") {
                monthsToAdd = frequencyMapped.SemiAnnual * feeTerm;
              } else if (paymentfrequency === "Annual") {
                monthsToAdd = frequencyMapped.Annual * feeTerm;
              }
              feeEndDate.setMonth(feeEndDate.getMonth() + monthsToAdd);
              feeEndDate.setDate(feeEndDate.getDate() - 1);
              return {
                ...row,
                start_date: Helper.DatePicker(feeStartDate),
                end_date: Helper.DatePicker(feeEndDate),
                paymentstart_date: Helper.DatePicker(feeStartDate),
                payment_frequency: paymentfrequency,
              };
            }
            if (row.payment_type === "Maintenance Fee") {
              let maintenanceStartDate = new Date(start_date);
              let maintenanceEndDate = new Date(maintenanceStartDate);

              if (paymentfrequency === "Monthly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Monthly;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + contractTerm
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Quarterly") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Quarterly;
                const month = frequencyMapped.Quarterly * contractTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Semi-annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.SemiAnnual;
                const month = frequencyMapped.SemiAnnual * contractTerm;
                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              } else if (paymentfrequency === "Annual") {
                if (paymentrule === "Advance") {
                  paymentstartDate = new Date(start_date);
                } else {
                  paymentstartDate = new Date(paymentstartdate);
                }
                contractTerm = contract_term / frequencyMapped.Annual;
                const month = frequencyMapped.Annual * contractTerm;

                maintenanceEndDate.setMonth(
                  maintenanceEndDate.getMonth() + month
                );
                maintenanceEndDate.setDate(maintenanceEndDate.getDate() - 1);
              }

              return {
                ...row,
                // no_of_payments: contractTerm,
                start_date: Helper.DatePicker(maintenanceStartDate),
                end_date: Helper.DatePicker(maintenanceEndDate),
                paymentstart_date: Helper.DatePicker(paymentstartDate),
                payment_frequency: paymentfrequency,
              };
            }
            return row;
          });

        return [...updatedRows, rentRow];
      });
    }
  }, [
    amount,
    paymentfrequency,
    paymentrule,
    paymentstartdate,
    contract_term,
    frequencyMapped,
    start_date,
    dataFetched,
    state,
  ]);

  const handlePaymentTypeChange = (index, event) => {
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].payment_frequency = paymentfrequency;

    const isOneTimeFee = paymentType.some(pt => pt.value === event && pt.fee_nature === 'One Time');

    if (isOneTimeFee) {
      const paymentTypeExists = updatedRowsData.some(
        (row, idx) => row.payment_type === event && idx !== index
      );

      if (paymentTypeExists) {
        setTermError(`${event} can only have one entry.`);
        return;
      }
    }

    updatedRowsData[index].payment_type = event;

    if (isOneTimeFee) {
      const contractTerm = contract_term / frequencyMapped.Monthly;
      let startDate = new Date(start_date);
      let paymentstartDate;

      if (paymentrule === "Advance") {
        paymentstartDate = new Date(start_date);
      } else {
        paymentstartDate = new Date(paymentstartdate);
      }
      let endDate = new Date(startDate);
      // const month = frequencyMapped.Annual * contractTerm;
      if (paymentfrequency === "Monthly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Quarterly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Semi-annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      }
    } else if (event === "Rent") {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    } else {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    }

    setRowsData(updatedRowsData);
  };

  // useEffect(()=>{
  //    setAmount(0)
  //    reset({
  //      paymentamount:0
  //   })
  //   setDataFetched(true)
  // },[start_date,contract_term,])

  const isDisabled = rowsData.length > 1;

  const handlePaymentFrequencyChange = (index, selectedValue) => {
    let updatedRowsData = [...rowsData];
    let startDate = new Date(start_date);
    let paymentstartDate;
    updatedRowsData[index].payment_frequency = paymentfrequency;

    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstartdate);
    }
    if (updatedRowsData[index].payment_type === "Maintenance Fee") {
      let contractTerm = null;
      if (selectedValue === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
      } else if (selectedValue === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
      } else if (selectedValue === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
      } else if (selectedValue === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
      }

      updatedRowsData[index].no_of_payments = "";
      updatedRowsData[index].start_date = Helper.DatePicker(startDate);
      updatedRowsData[index].payment_frequency = selectedValue;
      updatedRowsData[index].paymentstart_date =
        Helper.DatePicker(paymentstartDate);
      updatedRowsData[index].end_date = "";
      const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
        const payments = parseInt(row.no_of_payments, 10);
        return row.payment_type === "Maintenance Fee"
          ? sum + (isNaN(payments) ? 0 : payments)
          : sum;
      }, 0);
      if (totalPaymentsMaintentence > contractTerm) {
        setTermError(
          `Total number of Maintenance term ${contractTerm} is required`
        );
        return;
      }
    } else {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    }
    setRowsData(updatedRowsData);
  };

  return (
    <>
      <div className="container-fluid py-4">
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12">
            <div className="mb-0">
              <div className="header pb-0 mb-2">
                <div className="d-lg-flex">
                  <div>
                    <h5>{t("Contract Details")}</h5>
                    <h6>
                      <Link to="/contract" className="tc">
                        {t("Contracts")}
                      </Link>{" "}
                      / <span>{t("Contract Edit")}</span>
                    </h6>
                  </div>
                </div>
              </div>
              <Tabs
                selectedIndex={tabcontractIndex}
                onSelect={(index) => handleTabClick(index)}
              >
                <TabList>
                  <Tab onClick={handlecl}>
                    <p>{t("Contract Details")}</p>
                  </Tab>
                  <Tab>
                    <p>{t("Party Role")}</p>
                  </Tab>
                  <Tab>
                    <p>{t("Terms & Conditions")}</p>
                  </Tab>
                  <Tab>
                    <p>{t("Payment Schedules")}</p>
                  </Tab>
                  <Tab>
                    <p>{t("Assets Details")}</p>
                  </Tab>
                  <Tab onClick={clickontab}>
                    <p>{t("Amort Schedules")}</p>
                  </Tab>
                </TabList>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ToastContainer autoClose={2000} />
                    <SlidingPane
                      className="some-custom-class sidepanebar"
                      isOpen={state1.isPaneOpen}
                      title="Add Customer"
                      subtitle=""
                      onRequestClose={() => {
                        setState1({ isPaneOpen: false });
                      }}
                    >
                      <Form
                        role="form text-left"
                        onSubmit={handleSubmit2(handlepartydefault)}
                        ref={form2}
                        key={2}
                        action="."
                        method="POST"
                        id="addReceiptForm"
                      >
                        {
                          <>
                            <div className="row">
                              <div className="col-md-6">
                                <label className="col-form-label required">
                                  {t("Party Type")}{" "}
                                  <Tooltip content={t("PartyType_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <div className="form-group row">
                                  <div
                                    className="form-check"
                                    style={{
                                      width: "25%",
                                      paddingLeft: "3.0em",
                                    }}
                                  >
                                    <input
                                      className="form-check-input"
                                      checked={
                                        party_type === "Customer" ? true : false
                                      }
                                      value="Customer"
                                      type="radio"
                                      name="vendor"
                                      id="flexRadioDefault2"
                                      onChange={(e) =>
                                        setParty_type(e.target.value)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioDefault2"
                                    >
                                      Customer
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="col-form-label required">
                                {t("Entity Type")}{" "}
                                <Tooltip content={t("EntityType_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="form-group row">
                                <div
                                  className="form-check"
                                  style={{
                                    width: "25%",
                                    paddingLeft: "2.73em",
                                  }}
                                >
                                  <input
                                    className="form-check-input"
                                    checked={
                                      customer_type === "Person" ? true : false
                                    }
                                    value="Person"
                                    type="radio"
                                    name="person"
                                    id="id_customer_type"
                                    {...register2("customer_type", {
                                      onChange: (e) => {
                                        handleshowhide(e);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    Person
                                  </label>
                                </div>
                                <div
                                  className="form-check"
                                  style={{
                                    width: "25%",
                                    paddingLeft: "4.73em",
                                  }}
                                >
                                  <input
                                    className="form-check-input"
                                    checked={
                                      customer_type === "Organization"
                                        ? true
                                        : false
                                    }
                                    value="Organization"
                                    type="radio"
                                    name="organization"
                                    id="id_customer_type"
                                    {...register2("customer_type", {
                                      onChange: (e) => {
                                        handleshowhide(e);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    Organization
                                  </label>
                                </div>
                              </div>

                              <div className="invalid-feedback">
                                {errors2.customer_type?.type === "required" &&
                                  "Entity Type  is required"}
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-md-12">
                                <label className="col-form-label required">
                                  {t("Party Name")}{" "}
                                  <Tooltip content={t("PartyName_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Party Name")}
                                  className="form-control"
                                  type="text"
                                  value={customer_nameparty}
                                  name="customer_name"
                                  maxLength="200"
                                  id="id_customer_name"
                                  {...register2("customer_name", {
                                    onChange: (e) => {
                                      setCustomer_nameParty(e.target.value);
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors2.customer_name?.type === "required" &&
                                    "Party Name  is required"}
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("Address Line 1")}{" "}
                                    <Tooltip content={t("Address_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Address Line 1")}
                                    className="form-control"
                                    type="text"
                                    name="address_line_1"
                                    maxLength="200"
                                    id="id_address_line_1"
                                    value={address_line_1}
                                    {...register2("address_line_1", {
                                      onChange: (e) => {
                                        setAddress_line_1(e.target.value);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors2.address_line_1?.type ===
                                      "required" && "Address is required"}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label">
                                    {t("Address Line 2")}{" "}
                                    <Tooltip content={t("Address2_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Address Line 2")}
                                    className="form-control"
                                    type="text"
                                    onChange={(e) =>
                                      setAddress_line_2(e.target.value)
                                    }
                                    name="address_line_2"
                                    maxLength="200"
                                    id="id_address_line_2"
                                    value={address_line_2}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("City")}{" "}
                                    <Tooltip content={t("City_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("City")}
                                    className="form-control"
                                    type="text"
                                    name="city"
                                    maxLength="100"
                                    id="id_city"
                                    value={city}
                                    {...register2("city", {
                                      onChange: (e) => {
                                        setCity(e.target.value);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors2.city?.type === "required" &&
                                      "City is required"}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("State")}{" "}
                                    <Tooltip content={t("State_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("State")}
                                    className="form-control"
                                    type="text"
                                    name="state"
                                    maxLength="30"
                                    id="id_state"
                                    value={stateaddress}
                                    {...register2("state", {
                                      onChange: (e) => {
                                        setStateAddress(e.target.value);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors2.state?.type === "required" &&
                                      "State is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("Zip Code")}{" "}
                                    <Tooltip content={t("ZipCode_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Zip Code")}
                                    className="form-control"
                                    type="text"
                                    name="zip_code"
                                    maxLength="30"
                                    id="id_zip_code"
                                    value={zip_code}
                                    {...register2("zip_code", {
                                      onChange: (e) => {
                                        setZip_code(e.target.value);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors2.zip_code?.type === "required" &&
                                      "Zip Code is required"}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="col-form-label required">
                                    {t("Country")}{" "}
                                    <Tooltip content={t("Country_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Country")}
                                    className="form-control"
                                    type="text"
                                    name="country"
                                    maxLength="50"
                                    id="id_country"
                                    value={country}
                                    {...register2("country", {
                                      onChange: (e) => {
                                        setCountry(e.target.value);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors2.country?.type === "required" &&
                                      "Country is required"}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              type="submit"
                              disabled={disableparty}
                              className="border-0 btn btn-primary btn-gradient-primary btn-md"
                            >
                              {t("Save")}
                            </button>
                            &nbsp;&nbsp;
                          </>
                        }
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn2}
                        />
                      </Form>
                    </SlidingPane>
                    <SlidingPane
                      className="some-custom-class sidepanebarcontract"
                      isOpen={state5.isPaneOpen}
                      title="Add Payment Amount"
                      subtitle=""
                      onRequestClose={() => {
                        setState5({ isPaneOpen: false });
                        setTermError("");
                      }}
                    >
                      <Form
                        role="form text-left"
                        ref={form6}
                        key={6}
                        onSubmit={handleSubmit6(handlePayment)}
                        method="POST"
                        id="addPaymentAmount"
                      >
                        <>
                          <div className="table-responsive-sm">
                            <div className="row pt-3">
                              <div className="col-xl-6">
                                <label className="col-form-label">
                                  {t("Payment Lines")}
                                </label>
                              </div>
                              <div className="col-xl-6">
                                <div className="text-right ">
                                  <button
                                    type="button"
                                    className="btn btn-outline-success"
                                    onClick={addTableRows}
                                  >
                                    + {t("ADD")}
                                  </button>
                                </div>
                              </div>
                            </div>
                            <table
                              id="invoice"
                              className="table table-nowrap mb-0"
                            >
                              <thead>
                                <th>
                                  {t("Line no.")}{" "}
                                  <Tooltip content={t("LineNumber_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Payment Type")}{" "}
                                  <Tooltip content={t("PaymentType_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Amount")}{" "}
                                  <Tooltip content={t("Amount_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Payment Frequency")}{" "}
                                  <Tooltip content={t("PaymentType_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Total Terms")}{" "}
                                  <Tooltip content={t("Totalterm_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Date From")}{" "}
                                  <Tooltip content={t("Datefrom_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                                <th>
                                  {t("Date To")}{" "}
                                  <Tooltip content={t("Dateto_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </th>
                              </thead>
                              <tbody>
                                {rowsData.map((data, index) => (
                                  <tr key={index}>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Line no.")}{" "}
                                        <Tooltip
                                          content={t("LineNumber_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>{index + 1}</div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Payment Type")}{" "}
                                        <Tooltip
                                          content={t("PaymentType_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <select
                                          typeof="text"
                                          className="form-control"
                                          value={data.payment_type}
                                          onChange={(evnt) =>
                                            handlePaymentTypeChange(
                                              index,
                                              evnt.target.value
                                            )
                                          }
                                          name="payment_type"
                                        >
                                          {/* <option value="Rent">Rent</option>
                                          {paymentType.map((key, i) => (
                                            <option
                                              key={i}
                                              value={key.fee_name}
                                            >
                                              {key.fee_name}
                                            </option>
                                          ))} */}
                                          <option value="Rent">Payment</option>
                                          {paymentType.map((key, i) => (
                                            <option
                                              key={i}
                                              value={key.value}
                                            >
                                              {key.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Amount")}{" "}
                                        <Tooltip content={t("Amount_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <input
                                          type="text"
                                          placeholder="amount"
                                          value={data.amount}
                                          // onChange={(evnt) =>
                                          //   handelChangeAmount(
                                          //     index,
                                          //     evnt.target.value
                                          //   )
                                          // }
                                          onChange={(evnt) => {
                                            const val = evnt.target.value;
                                            if (/^\d*\.?\d{0,2}$/.test(val)) {
                                              handelChangeAmount(index, val);
                                            }
                                          }}
                                            name="termItem"
                                          className="form-control"
                                        />
                                        <div className="invalid-feedback">
                                          {errors.amount &&
                                            "Amount is required"}
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Payment Type")}{" "}
                                        <Tooltip
                                          content={t("PaymentType_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <select
                                          className="form-control"
                                          value={data.payment_frequency}
                                          disabled={
                                            data.payment_type === "Rent" ||
                                            paymentType.some(
                                              (pt) =>
                                                pt.value === data.payment_type &&
                                                pt.fee_nature === "One Time"
                                            )
                                          }
                                          onChange={(evnt) =>
                                            handlePaymentFrequencyChange(
                                              index,
                                              evnt.target.value
                                            )
                                          }
                                          name="payment_frequency"
                                        >
                                          {paymentFrequencystep.map(
                                            (key, i) => (
                                              <option key={i} value={key.label}>
                                                {key.label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Total Terms")}{" "}
                                        <Tooltip
                                          content={t("Totalterm_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <input
                                          type="text"
                                          placeholder="Term"
                                          value={
                                            paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time'
                                              ? 1
                                              : data.no_of_payments
                                          }
                                          onChange={(evnt) =>
                                            handleTermChange(
                                              index,
                                              evnt.target.value
                                            )
                                          }
                                          name="termItem"
                                          className="form-control"
                                          disabled={
                                            paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time'
                                          }
                                          style={{
                                            width: "80px",
                                            fontSize: "12px",
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Date From")}{" "}
                                        <Tooltip
                                          content={t("Datefrom_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <input
                                          disabled
                                          type="text"
                                          className="form-control"
                                          name="date_from"
                                          id="payment_startdate"
                                          value={Helper.Dateview(
                                            data.start_date
                                          )}
                                          style={{
                                            width: "80px",
                                            fontSize: "12px",
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Date To")}{" "}
                                        <Tooltip content={t("Dateto_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </div>
                                      <div>
                                        <input
                                          disabled
                                          type="text"
                                          className="form-control"
                                          name="date_to"
                                          id="payment_enddate"
                                          value={Helper.Dateview(data.end_date)}
                                          style={{
                                            width: "80px",
                                            fontSize: "12px",
                                          }}
                                        />
                                      </div>
                                    </td>

                                    <td>
                                      <button
                                        className="btn btn-outline-danger "
                                        onClick={() => deleteTableRows(index)}
                                      >
                                        x
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {termError && (
                              <div className="invalid-feedback">
                                {termError}
                              </div>
                            )}
                          </div>
                        </>
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn6}
                        />
                        <button
                          type="submit"
                          className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                          // disabled={disablebutton}
                          style={{ marginTop: "5%" }}
                        // onClick={handlePayment}
                        >
                          {t("Save")}
                        </button>
                      </Form>
                    </SlidingPane>
                    <div className="header mb-3 pb-0 d-flex align-items-center justify-content-between">
                      {/* <div className="header  mb-3 pb-0"> */}
                      <h5 className="mb-3  text-md-start">
                        {t("Contract Edit")}
                      </h5>
                      {/* </div> */}
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <div className="col-md-12">
                          <div className="row">
                            {/* <div className="col-md-12"> */}
                            {isLoading !== true ? (
                              <Form
                                role="form text-left"
                                onSubmit={handleSubmit(handleRegister)}
                                ref={form}
                                action="."
                                method="POST"
                                id="addPartyForm"
                              >
                                {
                                  <>
                                    <div className="row">
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("Sub Company")}{" "}
                                            <Tooltip
                                              content={t("Subcompany_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <select
                                              className="form-control"
                                              value={parseInt(subcompany)}
                                              name="subcompany"
                                              id="subcompany"
                                              {...register("subcompany", {
                                                onChange: (e) => {
                                                  setSubcompany(e.target.value);
                                                },
                                                required: false,
                                              })}
                                            >
                                              <option value="">
                                                {t("Select Subcompany")}
                                              </option>
                                              {subcompanyOptions.map(
                                                (option) => (
                                                  <option
                                                    key={option.id}
                                                    value={option.id}
                                                  >
                                                    {option.sub_company_name}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                            <div className="invalid-feedback">
                                              {errors.subcompany &&
                                                errors.subcompany.message}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("Line of Business")}{" "}
                                            <Tooltip
                                              content={t(
                                                "Lineofbusiness_Tooltip"
                                              )}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <select
                                              className="form-control"
                                              name="lineOfBusiness"
                                              id="lineOfBusiness"
                                              value={lineOfBusiness}
                                              {...register("lineOfBusiness", {
                                                onChange: (e) => {
                                                  setLineOfBusiness(
                                                    e.target.value
                                                  );
                                                },
                                                required: false,
                                              })}
                                            >
                                              <option value="">
                                                {t("Select Line of Business")}
                                              </option>
                                              {lineOfBusinessOptions.map(
                                                (option) => (
                                                  <option
                                                    key={option.id}
                                                    value={option.id}
                                                  >
                                                    {option.lob_name}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                            <div className="invalid-feedback">
                                              {errors.lineOfBusiness &&
                                                errors.lineOfBusiness.message}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label required">
                                            {t("Contract Number")}{" "}
                                            <Tooltip
                                              content={t("Contract_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <input
                                              disabled
                                              type="text"
                                              value={contract_number}
                                              onChange={(e) =>
                                                setContract_number(
                                                  e.target.value
                                                )
                                              }
                                              className="form-control"
                                              name="contract_number"
                                              id="contract_number"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-12 col-form-label">
                                          {t("Contract Type")}{" "}
                                          <Tooltip
                                            content={t("ContractType_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-lg-12">
                                          <input
                                            disabled
                                            type="text"
                                            value={contract_type}
                                            className="form-control"
                                            name="contract_type"
                                            id="contract_type"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label required">
                                            {t("Customer")}{" "}
                                            <Tooltip
                                              content={t("Customer_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-11">
                                            <AsyncSelect
                                              {...register("selectedValue", {
                                                required: true,
                                              })}
                                              defaultOptions={options}
                                              isClearable
                                              options={options}
                                              value={options.find(
                                                (option) =>
                                                  option.id === selectedValue
                                              )}
                                              getOptionLabel={(e) =>
                                                e.customer_name
                                              }
                                              getOptionValue={(e) => e.id}
                                              loadOptions={loadOptions}
                                              onInputChange={handelInputChange}
                                              onChange={handelChange}
                                              placeholder="Select a customer"
                                              name="selectedValue"
                                            ></AsyncSelect>
                                            <div className="invalid-feedback">
                                              {errors.selectedValue &&
                                                "Customer is required"}
                                            </div>
                                          </div>
                                          <div className="col-lg-1">
                                            <img
                                              onClick={() =>
                                                setState1({ isPaneOpen: true })
                                              }
                                              className=""
                                              style={{
                                                height: "20px",
                                                cursor: "pointer",
                                                marginLeft: "-5px",
                                              }}
                                              src={
                                                process.env.PUBLIC_URL +
                                                "/static/images/iconplus.png"
                                              }
                                              alt="ADD"
                                            ></img>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-12 col-form-label required">
                                          {t("Bill to Address")}{" "}
                                          <Tooltip
                                            content={t("BilltoAddress_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-lg-12">
                                          {/* <select
                                      value={address_id}
                                      name="address"
                                      id="bill_address"
                                      className="form-control input-lg form-select"
                                      data-live-search="true"
                                      title="Select Address"
                                      placeholder={address_id}
                                      {...register("address", {
                                        onChange: (e) => {
                                          setAdddressId(e.target.value);
                                        },
                                        required: true,
                                      })}
                                    >
                                      <option value="">
                                        ---{t("Select Address")}---
                                      </option>
                                      {address.map((key) => (
                                        <option key={key.id} value={key.id}>
                                          {key.address_line_1},{" "}
                                          {key.address_line_2 !== ""
                                            ? `${key.address_line_2},`
                                            : ""}{" "}
                                          {key.city}, {key.state}, {key.country}
                                        </option>
                                      ))}
                                    </select> */}
                                          <AsyncSelect
                                            {...register("address", {
                                              required: true,
                                            })}
                                            name="address"
                                            cacheOptions
                                            defaultOptions={filterBill}
                                            isClearable
                                            isSearchable
                                            options={filterBill}
                                            getOptionLabel={(option) =>
                                              option.label
                                            }
                                            getOptionValue={(option) =>
                                              option.value
                                            }
                                            onChange={handleBillAddressChange}
                                            loadOptions={loadOptionBillAdd}
                                            value={filterBill.find(
                                              (val) => val.value === address_id
                                            )}
                                            placeholder={`${t(
                                              "Search Address"
                                            )}`}
                                          />
                                          <div className="invalid-feedback">
                                            {errors.address?.type ===
                                              "required" &&
                                              "Address  is required"}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("IRR/Interest p.a.")}
                                            <Tooltip
                                              content={t(
                                                "IRR/Interestp.a_Tooltip"
                                              )}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <input
                                              type="text"
                                              value={Helper.Amount(
                                                contract_iir
                                              )}
                                              id="interest"
                                              name="interest"
                                              className="form-control"
                                              disabled
                                            />
                                            {amortError ? (
                                              <div className="invalid-feedback mt-3" >
                                                {amortError}
                                              </div>)
                                              : null}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label required">
                                            {t("Term")}{" "}
                                            <Tooltip
                                              content={t("Term_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={contract_term}
                                              name="contract_term"
                                              id="contract_term"
                                              {...register("contract_term", {
                                                required: "Term is required",
                                                max: {
                                                  value:
                                                    free.length !== 0
                                                      ? free[0].contract_term
                                                      : 60,
                                                  // message: `Term should not be more than ${free.length !== 0 ? free[0].contract_term : 60} for this user plan`,
                                                  message: `Maximum term is 60 months. Please enter a term between 1 and 60.`,
                                                },
                                                validate: {
                                                  positiveWholeNumber: (
                                                    value
                                                  ) => {
                                                    const numberValue =
                                                      Number(value);
                                                    if (isNaN(numberValue)) {
                                                      return "Only numbers are allowed";
                                                    } else if (
                                                      numberValue % 1 !==
                                                      0
                                                    ) {
                                                      return "Decimal numbers are not allowed";
                                                    } else if (
                                                      !Number.isInteger(
                                                        numberValue
                                                      ) ||
                                                      numberValue <= 0
                                                    ) {
                                                      return "Only positive numbers are allowed";
                                                    }
                                                    return true;
                                                  },
                                                },
                                                onChange: (e) => {
                                                  handelContract_term(
                                                    e.target.value
                                                  );
                                                },
                                              })}
                                            />
                                            <div className="invalid-feedback">
                                              {errors.contract_term &&
                                                errors.contract_term.message}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label required">
                                            {t("Start Date")}{" "}
                                            <Tooltip
                                              content={t("StartDate_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <DatePicker
                                              {...register("startdate", {
                                                required: true,
                                              })}
                                              className="form-control"
                                              selected={
                                                start_date
                                                  ? new Date(start_date)
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                handelStart_Date(e)
                                              }
                                              name="startdate"
                                              placeholderText={"mm/dd/yyyy"}
                                              showYearDropdown // year show and scrolldown alos
                                              scrollableYearDropdown
                                              showMonthDropdown
                                              dropdownMode="select"
                                            />
                                            <div className="invalid-feedback">
                                              {errors.startdate &&
                                                "Start Date  is required"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("End Date")}{" "}
                                            <Tooltip
                                              content={t("EndDate_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <input
                                              disabled
                                              type="text"
                                              value={Helper.Dateview(end_date)}
                                              className="form-control"
                                              id="enddate"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-6 col-form-label text-left required">
                                          {t("Payment Rule")}{" "}
                                          <Tooltip
                                            content={t("PaymentRule_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <select
                                          id="paymentrule"
                                          className="form-control"
                                          name="paymentrule"
                                          value={paymentrule}
                                          {...register("paymentrule", {
                                            onChange: (e) => {
                                              setPaymentRule(e.target.value);
                                              setDataFetched(true);
                                            },
                                            required: true,
                                          })}
                                        >
                                          <option value="">
                                            {t("Select Payment Rule")}
                                          </option>
                                          <option value="Advance">
                                            {t("Advance")}
                                          </option>
                                          <option value="Arrears">
                                            {t("Arrears")}
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.paymentrule &&
                                            "Payment Rule is required"}
                                        </div>
                                      </div>
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                        <label className="col-lg-6 col-form-label text-left required">
                                          {t("Frequency")}{" "}
                                          <Tooltip
                                            content={t("Frequency_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <select
                                          id="frequency"
                                          className="form-control"
                                          name="frequency"
                                          value={paymentfrequency}
                                          {...register("frequency", {
                                            onChange: (e) => {
                                              setPaymentFrequency(
                                                e.target.value
                                              );
                                              setDataFetched(true);
                                            },
                                            required: true,
                                          })}
                                        >
                                          <option value="">
                                            {t("Select Frequency")}
                                          </option>
                                          <option value="Monthly">
                                            {t("Monthly")}
                                          </option>
                                          <option value="Quarterly">
                                            {t("Quarterly")}
                                          </option>
                                          <option value="Semi-annual">
                                            {t("Semi-annual")}
                                          </option>
                                          <option value="Annual">
                                            {t("Annual")}
                                          </option>
                                        </select>
                                        <div className="invalid-feedback">
                                          {errors.frequency &&
                                            "Frequency is required"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="form-group row">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                          <div className="form-group row">
                                            <label className="col-lg-12 col-form-label text-left required">
                                              {t("Payment Amount")}{" "}
                                              <Tooltip
                                                content={t(
                                                  "PaymentAmount_Tooltip"
                                                )}
                                              >
                                                <i className="fa fa-light fa-circle-info"></i>
                                              </Tooltip>
                                            </label>
                                            <div className="col-lg-11">
                                              {rowsData.length > 1 ? (
                                                <input
                                                  className="form-control"
                                                  value="Multiple"
                                                  disabled={true}
                                                />
                                              ) : (
                                                <CurrencyInput
                                                  className="form-control"
                                                  {...register(
                                                    "paymentamount",
                                                    {
                                                      required:
                                                        isDisabled === true
                                                          ? false
                                                          : "Payment amount is required",
                                                      validate:
                                                        isDisabled === true
                                                          ? false
                                                          : {
                                                            positive: (v) =>
                                                              parseInt(v) >
                                                              0 ||
                                                              "Only positive numbers are allowed",
                                                          },
                                                    }
                                                  )}
                                                  value={amount}
                                                  onValueChange={(value) => {
                                                    setAmount(value);
                                                    setDataFetched(true);
                                                  }}
                                                  name="paymentamount"
                                                  id="input-example"
                                                  disabled={isDisabled}
                                                  allowDecimals="false"
                                                  disableAbbreviations
                                                />
                                              )}
                                              <div className="invalid-feedback">
                                                {errors.paymentamount &&
                                                  errors.paymentamount.message}
                                              </div>
                                            </div>
                                            <div className="col-lg-1">
                                              <img
                                                onClick={() =>
                                                  setState5({
                                                    isPaneOpen: true,
                                                  })
                                                }
                                                className=""
                                                style={{
                                                  height: "20px",
                                                  cursor: "pointer",
                                                  marginLeft: "-5px",
                                                }}
                                                src={
                                                  process.env.PUBLIC_URL +
                                                  "/static/images/iconplus.png"
                                                }
                                                alt="ADD"
                                              ></img>
                                            </div>
                                          </div>
                                          <div className="row mb-4">
                                            <div className="col-md-6 mb-3 mb-md-0">
                                              <label className="col-form-label">
                                                {t("ACH Payments")}{" "}
                                                <Tooltip
                                                  content={t(
                                                    "ACH_Payments_Tooltip"
                                                  )}
                                                >
                                                  <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip>
                                              </label>
                                              <div className="form-check">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  id="achPayments"
                                                  checked={achPayments}
                                                  {...register("achPayments", {
                                                    onChange: (e) =>
                                                      setAchPayments(
                                                        e.target.checked
                                                      ),
                                                  })}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="achPayments"
                                                >
                                                  Enable ACH Payments
                                                </label>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <label className="col-form-label ">
                                                {t("Bank Account")}{" "}
                                                <Tooltip
                                                  content={t(
                                                    "Bank_Account_Tooltip"
                                                  )}
                                                >
                                                  <i className="fa fa-light fa-circle-info"></i>
                                                </Tooltip>
                                              </label>
                                              <select
                                                className="form-control"
                                                id="achAccount"
                                                {...register("achAccount", {
                                                  // required: achPayments
                                                  // ? "Bank Account is required when ACH Payments is enabled"
                                                  // : false,
                                                  required: false,
                                                  onChange: (e) =>
                                                    setAchAccount(
                                                      e.target.value
                                                    ),
                                                })}
                                                value={achAccount}
                                                disabled={
                                                  !achPayments ||
                                                  achAccounts.length === 0
                                                }
                                              >
                                                <option value="">
                                                  Select Bank Account
                                                </option>
                                                {achAccounts.map((account) => (
                                                  <option
                                                    key={account.id}
                                                    value={account.id}
                                                  >
                                                    {account.account_name ||
                                                      `Account ${account.id}`}
                                                  </option>
                                                ))}
                                              </select>
                                              <div className="invalid-feedback">
                                                {errors.achAccount &&
                                                  errors.achAccount.message}
                                              </div>
                                            </div>
                                            {/* <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                              <div className="form-group row">
                                                <label className="col-lg-12 col-form-label">
                                                  {t("Application Originator")}{" "}
                                                  <Tooltip
                                                    content={t(
                                                      "ApplicationOrginator_Tooltip"
                                                    )}
                                                  >
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                  </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                  <input
                                                    type="text"
                                                    placeholder="Enter Application Originator"
                                                    className="form-control"
                                                    value={appOriginator}
                                                    onChange={(e) =>
                                                      setAppOriginator(
                                                        e.target.value
                                                      )
                                                    }
                                                    name="appOriginator"
                                                    id="appOriginator"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                              <div className="form-group row">
                                                <label className="col-lg-12 col-form-label">
                                                  {t("Source")}{" "}
                                                  <Tooltip
                                                    content={t(
                                                      "Source_Tooltip"
                                                    )}
                                                  >
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                  </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Source"
                                                    value={source}
                                                    onChange={(e) =>
                                                      setSource(e.target.value)
                                                    }
                                                    name="source"
                                                    id="source"
                                                  />
                                                </div>
                                              </div>
                                            </div> */}
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                              <div className="form-group row">
                                                <label className="col-lg-12 col-form-label">
                                                  {t("Sales Representative")}{" "}
                                                  <Tooltip
                                                    content={t(
                                                      "SalesRep_Tooltip"
                                                    )}
                                                  >
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                  </Tooltip>
                                                </label>
                                                <div className="col-lg-12">
                                                  <input
                                                    type="text"
                                                    placeholder="Enter Sales Rep"
                                                    className="form-control"
                                                    value={salesRep}
                                                    onChange={(e) =>
                                                      setSalesRep(
                                                        e.target.value
                                                      )
                                                    }
                                                    name="salesRep"
                                                    id="salesRep"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        {rowsData && rowsData.length > 0 && (
                                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <MaterialTable
                                              // tableRef={tableRef}
                                              style={{
                                                backgroundColor:
                                                  "var(--bs-table-bg)",
                                                borderBottomWidth: "1px",
                                                boxShadow:
                                                  "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                              }}
                                              title={
                                                <label className="col-lg-6 col-form-label text-left">
                                                  {t("Preview Payment Amounts")}{" "}
                                                  <Tooltip
                                                    content={t(
                                                      "Preview Payment Amounts"
                                                    )}
                                                  >
                                                    <i className="fa fa-light fa-circle-info"></i>
                                                  </Tooltip>
                                                </label>
                                              }
                                              columns={[
                                                {
                                                  title: `${t(
                                                    "No. of Payments"
                                                  )}`,
                                                  field: "no_of_payments",
                                                  headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  },
                                                  render: (rowData) => (
                                                    <>
                                                      {" "}
                                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("No. of Payments")}
                                                      </div>
                                                      <div>
                                                        {rowData.no_of_payments}
                                                      </div>
                                                    </>
                                                  ),
                                                },
                                                {
                                                  title: `${t("Payment Type")}`,
                                                  field: "payment_type",
                                                  render: (rowData) => (
                                                    <>
                                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("Payment Type")}
                                                      </div>{" "}
                                                      <div>
                                                        {rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}
                                                      </div>
                                                    </>
                                                  ),
                                                  headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  },
                                                },
                                                {
                                                  title: `${t("Amount")}`,
                                                  field: "amount",
                                                  render: (rowData) => (
                                                    <>
                                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("Amount")}
                                                      </div>
                                                      <div>
                                                        {Helper.Amount(rowData.amount)}
                                                      </div>
                                                    </>
                                                  ),
                                                  headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  },
                                                },
                                                {
                                                  title: `${t("Start Date")}`,
                                                  field: "start_date",
                                                  render: (rowData) => (
                                                    <>
                                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {" "}
                                                        {t("Start Date")}
                                                      </div>
                                                      <div>
                                                        {Helper.DateNormal(
                                                          rowData.start_date
                                                        )}
                                                      </div>
                                                    </>
                                                  ),
                                                  headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  },
                                                },
                                                {
                                                  title: `${t("End Date")}`,
                                                  field: "end_date",
                                                  render: (rowData) => (
                                                    <>
                                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("End Date")}
                                                      </div>
                                                      <div>
                                                        {Helper.DateNormal(
                                                          rowData.end_date
                                                        )}
                                                      </div>
                                                    </>
                                                  ),
                                                  headerStyle: {
                                                    verticalAlign: "inherit",
                                                    fontWeight: "bold",
                                                    textAlign: "left",
                                                  },
                                                  cellStyle: {
                                                    textAlign: "left",
                                                    fontSize: 12,
                                                  },
                                                },
                                              ]}
                                              data={rowsData}
                                              localization={{
                                                toolbar: {
                                                  searchPlaceholder:
                                                    "Search Contracts",
                                                },
                                              }}
                                              options={{
                                                headerStyle: {
                                                  backgroundColor: "white",
                                                  color: "#245C7F",
                                                  fontSize: 11,
                                                },
                                                rowStyle: (rowData, index) => {
                                                  if (index % 2) {
                                                    return {
                                                      backgroundColor: "#fff",
                                                    };
                                                  }
                                                },
                                                sorting: true,
                                                search: false,
                                                toolbar: true,
                                                paging: true,
                                                pageSize: 3, // make initial page size
                                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                                pageSizeOptions: [
                                                  3, 5, 10, 20, 25, 50,
                                                ],
                                                paginationType: "stepped",
                                                showFirstLastPageButtons: false,
                                                exportAllData: false,
                                                exportButton: false,
                                                actionsColumnIndex: -1,
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {extrafiledcontract.length === 0 ? (
                                      ""
                                    ) : (
                                      <h4 className="tc mt-4">
                                        {t("Additional Information")} :
                                      </h4>
                                    )}
                                    <div className="form-group row">
                                      {extrafiledcontract.map((key, index) => (
                                        <div
                                          className={
                                            key.enable === "True"
                                              ? "col-sm-6"
                                              : null
                                          }
                                        >
                                          <>
                                            <label
                                              style={{
                                                display:
                                                  key.enable === "True"
                                                    ? true
                                                    : "none",
                                              }}
                                              className="col-form-label"
                                            >
                                              {" "}
                                              {key.label}{" "}
                                              <Tooltip content={key.label}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                              </Tooltip>
                                            </label>
                                            <input
                                              style={{
                                                display:
                                                  key.enable === "True"
                                                    ? true
                                                    : "none",
                                              }}
                                              id={"attribute_" + index}
                                              value={
                                                attribute[index]["attribute"]
                                                  ? attribute[index][
                                                  "attribute"
                                                  ]
                                                  : ""
                                              }
                                              className="form-control mb-1"
                                              name="attribute"
                                              type={key.datatype}
                                              placeholder={key.label}
                                              onChange={(e) =>
                                                onChangeextrafileds(e, index)
                                              }
                                            />
                                          </>
                                        </div>
                                      ))}
                                    </div>
                                    <input
                                      type="hidden"
                                      value="Entered"
                                      className="form-control"
                                      name="status"
                                      id="status"
                                      disabled
                                    />
                                    <input
                                      type="hidden"
                                      className="form-control"
                                      name="sign_date"
                                      id="signdate"
                                    />
                                    <textarea
                                      style={{ display: "none" }}
                                      className="form-control"
                                      id="description"
                                      name="description"
                                    ></textarea>
                                    <input
                                      type="hidden"
                                      style={{ display: "none" }}
                                      value="USD"
                                      className="form-control"
                                      name="currency"
                                      id="currency"
                                    />
                                    <input
                                      type="hidden"
                                      value="{{ contract.address.id }}"
                                      id="contract_aid"
                                    />
                                    <input
                                      type="hidden"
                                      value="{{ contract.party.id }}"
                                      id="contract_cid"
                                    />
                                    <input
                                      type="hidden"
                                      value="{{ contract.id }}"
                                      id="contract_id"
                                    />
                                    <div className="text-left py-3 d-flex flex-wrap gap-2 align-items-center">
                                      <button
                                        type="submit"
                                        disabled={disablecontract}
                                        className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                      >
                                        {loading === false ? (
                                          t("Update")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                      &nbsp;&nbsp;
                                      {!isApprovalRequired && asset_count && payment_count ? (
                                        <button
                                          type="button"
                                          className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                          disabled={activeloading}
                                          onClick={handleactivation}
                                        >
                                          {activeloading === false ? (
                                            t("Activate Contract")
                                          ) : (
                                            <ButtonLoading />
                                          )}
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                      <span id="activeContract"></span>

                                      {isApprovalRequired && (
                                        <div style={{ marginLeft: "15px", fontSize: "13px", color: "#6c757d" }}>
                                          This transaction needs to be submitted for approval.
                                          <br />
                                          Please navigate to the view screen to submit for approval.
                                        </div>
                                      )}

                                    </div>
                                  </>
                                }
                                <CheckButton
                                  style={{ display: "none" }}
                                  ref={checkBtn}
                                />
                              </Form>
                            ) : (
                              <ContentLoader
                                viewBox="0 0 1000 550"
                                backgroundColor="rgba(0,0,0,0.06)"
                                foregroundColor="rgba(0,0,0,0.12)"
                              >
                                <rect
                                  x="51"
                                  y="45"
                                  rx="3"
                                  ry="3"
                                  width="906"
                                  height="17"
                                />
                                <circle cx="879" cy="123" r="11" />
                                <circle cx="914" cy="123" r="11" />
                                <rect
                                  x="104"
                                  y="115"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="305"
                                  y="114"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="661"
                                  y="114"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="55"
                                  y="155"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <circle cx="880" cy="184" r="11" />
                                <circle cx="915" cy="184" r="11" />
                                <rect
                                  x="105"
                                  y="176"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="306"
                                  y="175"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="662"
                                  y="175"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="56"
                                  y="216"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <circle cx="881" cy="242" r="11" />
                                <circle cx="916" cy="242" r="11" />
                                <rect
                                  x="106"
                                  y="234"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="307"
                                  y="233"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="663"
                                  y="233"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="57"
                                  y="274"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <circle cx="882" cy="303" r="11" />
                                <circle cx="917" cy="303" r="11" />
                                <rect
                                  x="107"
                                  y="295"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="308"
                                  y="294"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="664"
                                  y="294"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="58"
                                  y="335"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <circle cx="881" cy="363" r="11" />
                                <circle cx="916" cy="363" r="11" />
                                <rect
                                  x="106"
                                  y="355"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="307"
                                  y="354"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="663"
                                  y="354"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="57"
                                  y="395"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <circle cx="882" cy="424" r="11" />
                                <circle cx="917" cy="424" r="11" />
                                <rect
                                  x="107"
                                  y="416"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="308"
                                  y="415"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="664"
                                  y="415"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="55"
                                  y="453"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <rect
                                  x="51"
                                  y="49"
                                  rx="3"
                                  ry="3"
                                  width="2"
                                  height="465"
                                />
                                <rect
                                  x="955"
                                  y="49"
                                  rx="3"
                                  ry="3"
                                  width="2"
                                  height="465"
                                />
                                <circle cx="882" cy="484" r="11" />
                                <circle cx="917" cy="484" r="11" />
                                <rect
                                  x="107"
                                  y="476"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="308"
                                  y="475"
                                  rx="3"
                                  ry="3"
                                  width="299"
                                  height="15"
                                />
                                <rect
                                  x="664"
                                  y="475"
                                  rx="3"
                                  ry="3"
                                  width="141"
                                  height="15"
                                />
                                <rect
                                  x="55"
                                  y="513"
                                  rx="3"
                                  ry="3"
                                  width="897"
                                  height="2"
                                />
                                <rect
                                  x="52"
                                  y="80"
                                  rx="3"
                                  ry="3"
                                  width="906"
                                  height="17"
                                />
                                <rect
                                  x="53"
                                  y="57"
                                  rx="3"
                                  ry="3"
                                  width="68"
                                  height="33"
                                />
                                <rect
                                  x="222"
                                  y="54"
                                  rx="3"
                                  ry="3"
                                  width="149"
                                  height="33"
                                />
                                <rect
                                  x="544"
                                  y="55"
                                  rx="3"
                                  ry="3"
                                  width="137"
                                  height="33"
                                />
                                <rect
                                  x="782"
                                  y="56"
                                  rx="3"
                                  ry="3"
                                  width="72"
                                  height="33"
                                />
                                <rect
                                  x="933"
                                  y="54"
                                  rx="3"
                                  ry="3"
                                  width="24"
                                  height="33"
                                />
                              </ContentLoader>
                            )}
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                      <input
                        type="hidden"
                        value=""
                        id="contract_id"
                        name="contract_id"
                      />
                      <div className="row mt-4" id="payschedule"></div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ContractShortview
                      contract={contract}
                      TotalIncome={TotalIncome}
                      iir={contract_iir}
                    />

                    <PartyRoleList
                      id={state}
                      contracttype={contract_type}
                      setTab={tabcontractIndex}
                      party_id={customer_id}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ContractShortview
                      contract={contract}
                      TotalIncome={TotalIncome}
                      iir={contract_iir}
                    />

                    <TermConditionContractView
                      contract_id={state}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ContractShortview
                      contract={contract}
                      TotalIncome={TotalIncome}
                      iir={contract_iir}
                    />
                    <PaymentScheduleList
                      id={{
                        contract_id: state,
                        contract_start_date: start_date,
                        contract_term: contract_term,
                      }}
                      data_count={data_count}
                      refresh={setRefreshPaymentDetails}
                      contract_type={contract_type}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ContractShortview
                      contract={contract}
                      TotalIncome={TotalIncome}
                      iir={contract_iir}
                    />
                    {!assetid ? (
                      <AssetList
                        id={state}
                        contracttype={contract_type}
                        setTab={tabcontractIndex}
                        party_id={customer_id}
                      />
                    ) : (
                      <div className="mt-3 pt-5">
                        <AssetView
                          asset_id={assetid}
                          id={state}
                          contracttype={contract_type}
                          setassetID={setassetID}
                        ></AssetView>
                      </div>
                    )}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div
                    className="panel-content"
                    style={{ paddingLeft: "10px" }}
                  >
                    <ContractShortview
                      contract={contract}
                      TotalIncome={TotalIncome}
                      iir={contract_iir}
                    />
                    {paymentrule === "Arrears" ? (
                      <AmortizationScheduleArrears
                        startdate={start_date}
                        key={key}
                        totalIncome={totalIncome}
                        totalRent={totalRent}
                        paymentfrequency={paymentfrequency}
                        financedamount={financed_amount}
                        deposit_amount={deposit_amount}
                        contract_term={contract_term}
                        feesontime={totalonetimefee}
                        contractiir={contract_iir}
                        paymentrule={paymentrule}
                        paymentamount={rentamount}
                        numberofpayment={numberofpayment}
                        residual={residual}
                        setarrears={calu}
                        amortcal={amortcalculation}
                        contracttype={contract_type}
                        amortError={amortError}
                      />
                    ) : (
                      <AmortizationSchedule
                        startdate={start_date}
                        Key={key}
                        totalIncome={totalIncome}
                        totalRent={totalRent}
                        paymentfrequency={paymentfrequency}
                        financedamount={financed_amount}
                        contractiir={contract_iir}
                        contract_term={contract_term}
                        feesontime={totalonetimefee}
                        paymentrule={paymentrule}
                        paymentamount={rentamount}
                        numberofpayment={numberofpayment}
                        residual={residual}
                        setarrears={calu}
                        amortcal={amortcalculation}
                        contracttype={contract_type}
                        amortError={amortError}
                      />
                    )}
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContractEdit;
